import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { serializeCdn } from './serializer';
import { CarnetDeNotes } from '@teetsh/app/src/containers/CarnetsDeNotes/types/carnetsDeNotes';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { cdnKeys } from '@teetsh/app/src/containers/CarnetsDeNotes/queries/keys';
import { useTranslation } from 'react-i18next';

function updateCDN({
  schoolyearId,
  schoolId,
  cdn,
}: {
  schoolyearId: string;
  schoolId: string;
  cdn: CarnetDeNotes;
}) {
  const requestURL = `/schoolyears/${schoolyearId}/schools/${schoolId}/carnets-de-notes/${cdn.id}`;
  return request(requestURL, {
    method: 'PATCH',
    body: serializeCdn(cdn),
  });
}

export function useUpdateCDN() {
  const { notifyError } = useNotification();
  const { schoolyear, school } = useSchoolSchoolyear();
  const queryClient = useQueryClient();
  const { t } = useTranslation(['carnet']);
  const { mutateAsync } = useMutation({
    mutationFn: (cdn: CarnetDeNotes) =>
      updateCDN({ schoolyearId: schoolyear.id, schoolId: school.id, cdn }),
    onMutate: cdn => {
      queryClient.setQueryData<CarnetDeNotes>(
        cdnKeys.cdnDetail(schoolyear.id, school.id, cdn.id),
        cdn,
      );
    },
    onError: () => {
      notifyError({
        title: t('carnet:messages.cdn.updateError'),
      });
    },
  });
  return mutateAsync;
}
